<div class="combo-input {isInSearchingState ? "searchingState" : ""}">
  <div class="combo-input-container">
    <div class="combo-input-wrapper">
    <LocationInput
        bind:searchString={searchString}
        hasValue={searchPromise || $store.searchResults.length > 0}
        isSearchDisabled={isSearchDisabled} 
        placeholder="Type in your suburb"
        combo={true}
        on:keyup={searchDebounced}
        on:focus={handleEnableSearch}
        on:focusout={handleDisableSearch}
        on:clear={clearSearch}
      />
    </div>
    <div class="combo-input-wrapper {isNotAOI ? 'disabled' : ''}">
      <div class="flood-likelihood-select-box" on:click|preventDefault={toggleLikelihood}>
        {#if selectedLikelihood}
          <p>{selectedLikelihood.label}</p>
        {:else}
          <p class="greyed">Select your flood likelihood</p>
        {/if}
        <span class="caret"></span>
      </div>
    </div>
  </div>
  <div class="combo-input-dropdown {searchPromise || isNotAOI ? "searchLocation" : ""} {selectDDActive ? "selectFlood" : ""}">
    {#if searchDDActive || isNotAOI}
      <LocationSuggestion
        searchPromise={searchPromise}
        on:goto={goTo}
        combo={true}
        isNotAOI={isNotAOI}
      />
    {/if}
    {#if selectDDActive}
      <div class="select-container">
        <div class="select-container-cta">
          <div class="plus-sign" on:click|preventDefault={toggleLikelihood}></div>
        </div>
        <FloodLikelihoodOptions
          selectedValue={selectedLikelihoodValue}
          combo={true}
        />
      </div>
    {/if}
  </div>
</div>
<div class="combo-input">
  <div class="combo-input-information-wrapper {isInSearchingState ? "hide" : ""}">
    <div 
      class="combo-input-information {showInformation ? "full-width" : ""}" 
      bind:this={comboInputInfoBg}>
      <div class="combo-input-information-cta {showInformation ? "rotate" : ""}" on:click={() => toggleInformation(!showInformation) }>
        <div class="plus-sign"></div>
      </div>
    </div>
    <div class="combo-input-information full-width {showInformation ? "transition-in" : ""}" bind:this={comboInputInfo}>
      <div class="combo-input-information-text">
        {#if selectedLikelihood} 
          <p>
            {#if !isNotAOI && selectedSuburb}
              In <span class="bold">{searchString}</span>, a 
            {:else}
              A
            {/if}
            {selectedLikelihood.tooltip}
          </p>
        {:else}
          <p>Floods that happen more often are smaller.</p>
          <p>Floods that happen rarely are much bigger.</p>
        {/if}
      </div>
    </div>
  </div>
</div>

<script>
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import store, { STATES_MAIN, STATES_START } from "../../state";
import utils from "../../utils";
import { debounce } from "ts-debounce";
import LocationSearchAPI from "../LocationSearch/LocationSearchAPI";
import LocationInput from "../LocationSearch/Input/Input.svelte";
LocationInput;
import LocationSuggestion from "../LocationSearch/Suggestion/Suggestion.svelte";
LocationSuggestion;
import FloodLikelihoodOptions from "../FloodLikelihood/Options/Options.svelte";
FloodLikelihoodOptions;
import { tick } from "svelte/internal";
const locationSearchAPI = new LocationSearchAPI();
// html vars
let searchString = "";
let searchPromise = undefined;
let isSearchDisabled = true;
let searchDebounced = debounce(handleSearch, 275);
let capitalize = utils.capitalize;
let searchDDActive = false;
let selectDDActive = false;
let selectedLikelihood = undefined;
let selectedLikelihoodValue = "";
let showInformation = false;
let isNotAOI = false;
let selectedSuburb = "";
let isInSearchingState = false;
let comboInputInfo;
let comboInputInfoBg;
store.subscribe(state => {
    var _a;
    const _tickAndShow = () => __awaiter(void 0, void 0, void 0, function* () {
        yield tick();
        setTimeout(() => toggleInformation(true));
    });
    const isInFirstTimeUserState = state.currentState.includes(`${STATES_MAIN.FIRST_VISIT}`);
    isInSearchingState = state.currentState.includes(`${STATES_MAIN.START}.${STATES_START.SEARCHING}`);
    if (!isInSearchingState &&
        state.riskProfile &&
        state.riskProfile.Suburb !== selectedSuburb) {
        searchString = capitalize(state.riskProfile.Suburb).value();
        selectedSuburb = state.riskProfile.Suburb;
        isNotAOI = ((_a = state.riskProfile) === null || _a === void 0 ? void 0 : _a.AOI) === "OUT" || false;
        showInformation && _tickAndShow();
    }
    else if (!isInSearchingState && !state.riskProfile) {
        selectedSuburb = "";
        searchString = "";
        isNotAOI = false;
        showInformation && _tickAndShow();
    }
    if (state.selectedLikelihood &&
        state.selectedLikelihood.value !== selectedLikelihoodValue) {
        selectedLikelihood = state.selectedLikelihood;
        selectedLikelihoodValue = selectedLikelihood.value;
        _tickAndShow();
        state.mapViewService.setVisibleFloodLayer(selectedLikelihoodValue);
        selectDDActive && toggleLikelihood();
    }
});
locationSearchAPI.store.subscribe(state => {
    isSearchDisabled = state.isSearchDisabled;
    searchPromise = state.searchPromise;
});
// html functions
function handleEnableSearch() {
    searchDDActive = true;
    selectDDActive = false;
    locationSearchAPI.handleEnableSearch();
    //@ts-ignore
    if (!$store.riskProfile || searchString.toUpperCase() !== selectedSuburb) {
        handleSearch();
    }
    else {
        //@ts-ignore
        isNotAOI = $store.riskProfile.AOI === "OUT";
    }
}
function handleDisableSearch() {
    // @ts-ignore
    if ($store.searchResults.length === 0) {
        searchDDActive = false;
        locationSearchAPI.handleDisableSearch();
    }
}
function handleSearch() {
    locationSearchAPI.handleSearch(searchString);
}
function goTo(event) {
    isNotAOI = false;
    locationSearchAPI.goTo(event.detail);
}
function clearSearch() {
    locationSearchAPI.clearSearch();
}
function toggleLikelihood() {
    if (!isNotAOI) {
        selectDDActive = !selectDDActive;
        searchDDActive = false;
        if (searchPromise) {
            searchPromise.cancel();
        }
        searchPromise = undefined;
        isNotAOI = false;
    }
}
function toggleInformation(show) {
    if (show) {
        let comboInputInfoAttr = comboInputInfo.getBoundingClientRect();
        comboInputInfoBg.style.height = `${comboInputInfoAttr.height}px`;
        if (!showInformation)
            comboInputInfo.style.visibility = "visible";
    }
    else {
        comboInputInfoBg.style.height = "";
        comboInputInfo.style.visibility = "";
    }
    showInformation = show;
}
</script>


<style>.combo-input{width:100%;top:48px;left:0;padding:0 18.75px;position:absolute;z-index:2}.combo-input.searchingState{z-index:5}.combo-input+.combo-input{top:92px;z-index:1;display:flex;justify-content:flex-end}.combo-input-container{width:100%;height:36px;border-radius:10px;background-color:#fff;border:1px solid #f08403;box-shadow:0 1px 6px 0 rgba(0,0,0,.5);display:flex}.combo-input-wrapper{width:50%;height:100%;position:relative}.combo-input-wrapper:first-child{border-right:.5px solid rgba(244,134,3,.2)}.combo-input-wrapper:last-child{border-left:.5px solid rgba(244,134,3,.2)}.combo-input-wrapper.disabled:before{content:"";background-color:#d2d2d2;position:absolute;left:0;top:0;width:100%;height:100%;opacity:.5}.combo-input-dropdown{position:relative}.combo-input-dropdown:before{content:"";position:absolute;display:none;top:0;width:0;height:0;border-color:#f08403 transparent transparent;border-style:solid;border-width:8.26px 8.13px 0;z-index:3}.combo-input-dropdown.searchLocation:before{display:block;left:25%}.combo-input-dropdown.selectFlood:before{display:block;right:25%}.combo-input-information-wrapper{position:relative;width:100%}.combo-input-information-wrapper.hide{display:none}.combo-input-information{border-radius:5px;background-color:hsla(0,0%,88.2%,.9);border:1px solid rgba(244,134,3,.5);box-shadow:3px 1px 6px 0 rgba(0,0,0,.5);font-size:.6875rem;line-height:15px;height:42px;width:44px;position:relative;overflow:hidden;padding:12px 0 12px 14.5px;position:absolute;visibility:visible;font-family:AvenirLT-Light}.combo-input-information:first-child{right:0;transition:width .25s ease-out,height .25s ease-out}.combo-input-information:last-child{left:0;width:calc(100% - 45px)!important;visibility:hidden;background-color:transparent;border:none;box-shadow:none}.combo-input-information:last-child.transition-in{transition:visibility .25s ease-out .25s}.combo-input-information.full-width{width:100%;height:auto}.combo-input-information-text .bold{font-family:AvenirLT-Black}.combo-input-information-cta{flex:0 0 auto;cursor:pointer;right:14px;top:12px;position:absolute}.combo-input-information-cta.rotate .plus-sign{transform:rotate(45deg)}.flood-likelihood-select-box{display:flex;align-items:center;height:100%;margin-left:8.25px;margin-right:14px;justify-content:space-between;cursor:pointer;font-family:AvenirLT-Light}.flood-likelihood-select-box p{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.flood-likelihood-select-box p.greyed{color:rgba(54,54,54,.3);font-size:.875rem}.flood-likelihood-select-box .caret{flex:0 0 auto;width:0;height:0;border-color:#f08403 transparent transparent;border-style:solid;border-width:4.45px 4.45px 0}.select-container{box-sizing:border-box;min-height:2.4rem;width:100%;border-radius:10px;background-color:#fff;border:1px solid #f08403;padding:16px 20px 30.5px}.select-container-cta{display:flex;justify-content:flex-end}.select-container-cta .plus-sign{cursor:pointer;transform:rotate(45deg)}</style>
